const CART_WRAPPER_SELECTOR = '#candyrack-slider-cart-wrapper';
const TEMPLATE_SELECTOR = '#candyrack-cart-b2b-template';
const MOUNT_SELECTOR = '[data-candyrack-cart-b2b]';
const FOOTER_SELECTOR = '.candyrack-slider-cart-footer-wrapper';
const BUTTONS_SELECTOR = '.candyrack-slider-cart-footer-buttons-wrapper';
const EMPTY_BUTTON_SELECTOR = '.candyrack-slider-cart-empty-cart-button';
const REFRESH_DELAY = 150;

let refreshTimer;
let refreshInFlight = false;
let refreshQueued = false;

/**
 * Keep GA4 cart_value in sync with the live CandyRack cart.
 */
async function refreshCartValue() {
  const links = document.querySelectorAll(`${CART_WRAPPER_SELECTOR} [data-b2b-info-link]`);
  if (!links.length) return;

  if (refreshInFlight) {
    refreshQueued = true;
    return;
  }

  refreshInFlight = true;
  try {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;

    const cart = await response.json();
    const cartValue = Number(cart.total_price || 0) / 100;

    for (const link of links) {
      link.setAttribute('data-cart-value', String(cartValue));
    }
  } catch {
    // Keep the template value if the cart endpoint is temporarily unavailable.
  } finally {
    refreshInFlight = false;

    if (refreshQueued) {
      refreshQueued = false;
      scheduleRefresh();
    }
  }
}

function scheduleRefresh() {
  window.clearTimeout(refreshTimer);
  refreshTimer = window.setTimeout(refreshCartValue, REFRESH_DELAY);
}

/**
 * Insert the B2B row above the footer checkout buttons, or below the empty-cart CTA.
 */
function mountB2bLink() {
  const cartWrapper = document.querySelector(CART_WRAPPER_SELECTOR);
  const template = document.querySelector(TEMPLATE_SELECTOR);

  if (!(cartWrapper instanceof HTMLElement) || !(template instanceof HTMLTemplateElement)) {
    return;
  }

  if (cartWrapper.querySelector(MOUNT_SELECTOR)) {
    scheduleRefresh();
    return;
  }

  const fragment = template.content.cloneNode(true);
  const mount = fragment.querySelector(MOUNT_SELECTOR);

  if (!(mount instanceof HTMLElement)) return;

  const footer = cartWrapper.querySelector(FOOTER_SELECTOR);

  if (footer instanceof HTMLElement) {
    const buttons = footer.querySelector(BUTTONS_SELECTOR);

    if (buttons instanceof HTMLElement) {
      footer.insertBefore(fragment, buttons);
    } else {
      footer.appendChild(fragment);
    }

    scheduleRefresh();
    return;
  }

  const emptyButton = cartWrapper.querySelector(EMPTY_BUTTON_SELECTOR);
  if (emptyButton instanceof HTMLElement && emptyButton.parentElement) {
    emptyButton.parentElement.insertBefore(fragment, emptyButton.nextSibling);
    scheduleRefresh();
  }
}

const pageObserver = new MutationObserver((records) => {
  const hasCartMutation = records.some((record) => {
    if (
      record.target instanceof Element &&
      (record.target.matches(CART_WRAPPER_SELECTOR) || record.target.closest(CART_WRAPPER_SELECTOR))
    ) {
      return true;
    }

    return Array.from(record.addedNodes).some(
      (node) =>
        node instanceof Element &&
        (node.matches(CART_WRAPPER_SELECTOR) || node.querySelector(CART_WRAPPER_SELECTOR))
    );
  });

  if (hasCartMutation) mountB2bLink();
});

pageObserver.observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('cart:update', () => {
  mountB2bLink();
  scheduleRefresh();
});
mountB2bLink();
